exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".is-checkradio[type=checkbox]:checked+label[data-v-1976b80b]:before,.is-checkradio[type=radio]:checked+label[data-v-1976b80b]:before{border:.15rem solid #dbdbdb}.is-checkradio[type=checkbox]+label[data-v-1976b80b]:after{border-width:.15rem}.fieldUserType[data-v-1976b80b]{margin-top:20px;margin-bottom:25px}.fieldsub[data-v-1976b80b]{margin-top:5px;margin-bottom:10px}.fieldsub span[data-v-1976b80b]{font-weight:700}.mainContent[data-v-1976b80b]{padding:0 60px}.name-role[data-v-1976b80b]{width:100%;text-overflow:ellipsis!important;text-align:center;white-space:nowrap;overflow:hidden;position:relative;display:inline-block;text-transform:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1976b80b","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/users/EditUser.vue
// module id = 691
// module chunks = 2